import { useState } from 'react'
import { useMutation, useQueryClient } from 'react-query'
import * as Sentry from '@sentry/react'
import Cookies from 'js-cookie'
import { updateCartContents } from '../api'
import { ERROR_UPDATING_CART } from '../errorConstants'

const useUpdateCart = () => {
    const queryClient = useQueryClient()
    const [errorMessage, setErrorMessage] = useState()

    const { mutate, isLoading, isSuccess, isError } = useMutation(
        updateCartContents,
        {
            onSuccess: (data) => {
                queryClient.setQueryData('cart', data)
            },
            onError: (error, context) => {
                const {
                    response: { data: errorMessage },
                } = error

                error.name = ERROR_UPDATING_CART
                if (errorMessage?.error_code) {
                    setErrorMessage(
                        `${errorMessage.error_code}: ${errorMessage.limit_overage}`
                    )
                    Sentry.captureException(error, {
                        extra: {
                            errorMessage: JSON.stringify(errorMessage),
                            context: JSON.stringify(context, null, 2),
                        },
                        user: {
                            id: JSON.stringify(
                                Cookies.get('GCG_CLIENT_USER_ID')
                            ),
                        },
                    })
                } else {
                    setErrorMessage(errorMessage.message)
                    Sentry.captureException(error, {
                        extra: {
                            errorMessage: JSON.stringify(errorMessage),
                            context: JSON.stringify(context, null, 2),
                        },
                        user: {
                            id: JSON.stringify(
                                Cookies.get('GCG_CLIENT_USER_ID')
                            ),
                        },
                    })
                }
            },
        }
    )

    return { mutate, isLoading, isSuccess, isError, errorMessage }
}

export default useUpdateCart
